import { useWSModal } from "@wingspanhq/fe-component-library";
import { EditContractorModal } from "./index";

export function useEditContractorModal() {
  return useWSModal(EditContractorModal, {
    title: "Edit contractor",
    size: "S"
  });
}
